import React, { useState } from 'react'
import './Accordian.css';
import SelectFromExamples from './SelectFromExamples';
import SelectFromUploads from './SelectFromUploads';
import { useFileDispatch } from '../context/FileContext';

const Accordian = () => {
  const [accordian, setAccordian] = useState("0");
  const [,,,, restFilesHandler,,, resetStatisticsHandler] = useFileDispatch();

  const toggleAccordian = (id) => {
    if(accordian === id) {
        setAccordian("0");
    } else {
        setAccordian(id);
    }

    restFilesHandler();
    resetStatisticsHandler();
  }

  return (
    <div className="selection-container">
      <div className="select-option">
        <SelectFromExamples />
      </div>
      <div className="select-option">
        <SelectFromUploads />
      </div>
    </div>
  );
}

export default Accordian;